// extracted by mini-css-extract-plugin
module.exports = {"SectionListGraph":"SectionListGraph_SectionListGraph__ehR9r"};